function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import * as React from 'react';
import { IconCheck, IconExclamationMark, IconCloseThin } from '../Icons';
import classnames from 'classnames';
import injectStyles from '../jss';
import styles from './Notification.jss';
var ICONS = {
  error: IconExclamationMark,
  info: IconCheck,
  neutral: null,
  warning: IconExclamationMark
};
export var Notification = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Notification, _React$PureComponent);
  function Notification() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, Notification);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Notification)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      isClosed: false
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_timerId", 0);
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCloseClick", function () {
      var onClose = _this.props.onClose;
      onClose();
      _this.setState({
        isClosed: true
      });
    });
    return _this;
  }
  _createClass(Notification, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var closeAfterTimeout = this.props.closeAfterTimeout;
      if (closeAfterTimeout) {
        this._timerId = window.setTimeout(function () {
          _this2.setState({
            isClosed: true
          });
        }, closeAfterTimeout);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._timerId) {
        window.clearTimeout(this._timerId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        children = _this$props.children,
        classNameProp = _this$props.className,
        message = _this$props.message,
        type = _this$props.type,
        closeable = _this$props.closeable;
      var isClosed = this.state.isClosed;
      if (!children && !message || isClosed) {
        return null;
      } // $FlowFixMe

      var Icon = ICONS[type];
      var className = classnames(classes.base, classes[type], classNameProp);
      var iconClasses = classnames(classes.icon, closeable && classes.centerIcon);
      var messageClasses = classnames(classes.message, _defineProperty({}, classes.centerIcon, closeable && type === 'neutral'));
      return React.createElement("div", {
        className: className
      }, Icon && React.createElement(Icon, {
        className: iconClasses
      }), children ? React.createElement(React.Fragment, null, children) : React.createElement("div", {
        className: messageClasses
      }, message), closeable && React.createElement(IconCloseThin, {
        className: classes.closeIcon,
        onClick: this.handleCloseClick
      }));
    }
  }]);
  return Notification;
}(React.PureComponent);
_defineProperty(Notification, "styleRoot", 'Notification');
_defineProperty(Notification, "defaultProps", {
  type: 'error',
  closeable: false,
  onClose: function onClose() {}
});
export default injectStyles(styles)(Notification);